// extracted by mini-css-extract-plugin
export var amountContainer = "WithdrawAmountInput-module--amountContainer--c4450";
export var currencyInput = "WithdrawAmountInput-module--currencyInput--dd822";
export var currencyInputWrapper = "WithdrawAmountInput-module--currencyInputWrapper--0d3c4";
export var disabled = "WithdrawAmountInput-module--disabled--ed7f8";
export var errorMessage = "WithdrawAmountInput-module--errorMessage--3fd27";
export var textMd = "WithdrawAmountInput-module--textMd--f509c";